import { ExtendedWebflowBenefit } from "../../../types";
import {
  IWebflowBenefitCategory,
  IWebflowBenefitMinimumSubscription
} from "@wingspanhq/cms/dist/lib/interfaces";
import {
  SubscriptionPackage,
  SubscriptionPackageTier
} from "@wingspanhq/users/dist/lib/interfaces";
import { PGLI_KEY, PLAN_DETAILS } from "../../../utils/constants";

const {
  monthlyPremiumFormatted,
  initiationFeeFormatted,
  monthlyPremium,
  initiationFee,
  name
} = PLAN_DETAILS[PGLI_KEY];

export const getPGLIBenefitListItem = (): ExtendedWebflowBenefit => {
  const benefit: ExtendedWebflowBenefit = {
    icon: "shield-check-fill",
    iconColor: "white",
    iconBackgroundColor: "garnet",
    helperLogo: {
      src: "",
      placeholder: ""
    },
    logo: {
      src: "",
      placeholder: ""
    },
    mainVideo: {
      src: ""
    },
    mainHeader: "",
    collectionId: "",
    editedOn: new Date(),
    isDraft: false,
    name,
    itemId: "",
    publishedOn: new Date(),
    slug: PGLI_KEY,
    category: IWebflowBenefitCategory.Insurance,
    minSubscription: IWebflowBenefitMinimumSubscription.Benefits,
    minSubscriptionPackage: SubscriptionPackage.Benefits,
    minSubscriptionPackageTier: SubscriptionPackageTier.Basic,
    atAGlance:
      "A Professional Liability (Errors & Omissions) and General Liability policy for specific, eligible professional groups",
    featured: false,
    helperCostDescription: `Cost: Only ${monthlyPremiumFormatted} per month + one time ${initiationFeeFormatted} setup fee.`,
    shortCostDescription: `${monthlyPremiumFormatted}/mo + ${initiationFeeFormatted} setup fee`,
    helperCostIsNotIncluded: true,
    helperHideMemberAndGroupInfo: true,
    isAdditionalCoverage: true,
    hidden: false,
    orderPriority: 11,
    isAssurely: true
  };

  return benefit;
};
